import { Flex, Button } from '@mantine/core';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { IoIosArrowForward } from 'react-icons/io';
import { useDuplicateWorkflow } from '../../../../services/workflow.services';
import toast from 'react-hot-toast';
import { FormInput } from '../../../../components/FormElements/FormInput';

export function DuplicateProject({ refetch, onClose, project }) {
  const { control, handleSubmit, setValue } = useForm();

  const duplicateWorkflow = useDuplicateWorkflow();

  useEffect(() => {
    if (project) setValue('projectName', `${project.name}-Copy`);
  }, [project]);

  const onSubmit = data => {
    duplicateWorkflow.mutate(
      {
        id: project.id,
        body: {
          name: data.projectName
        }
      },
      {
        onSuccess: res => {
          refetch();
          onClose();
        },
        onError: err => {
          toast.error(err?.data?.detail?.slice(0, 53));
          console.log(err);
        }
      }
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormInput name="projectName" control={control} label="AIFM Name" required />
      <Flex justify="flex-end" mt="48px">
        <Button
          loading={duplicateWorkflow.isLoading}
          type="submit"
          rightSection={<IoIosArrowForward />}
          size="sm"
        >
          Continue
        </Button>
      </Flex>
    </form>
  );
}
